import cloudImg from '../images/cloud.svg'

const FilePickerOverlay = (props) => {
  return (
    <div
      className={`producer-file-upload ${props.image || props.audioFile ? 'has-image' : ''} ${props.readOnly ? 'readOnly' : ''}`}
      style={{ backgroundImage: `url(${props.image})` }}
    >
      {props.audioFile &&
        <div className='producer-file-upload__audio-file-name'>
          {props.audioFile}
        </div>
      }

      {(props.image || props.audioFile) &&
        <div className='overlay'></div>
      }

      <label htmlFor={props.inputName} className={props.readOnly ? 'readOnly' : ''}>
        <img src={cloudImg} alt='Upload File' />
        <div className='producer-file-upload__title'>{props.title}</div>
        {props.description &&
          <div
            className='producer-file-upload__description'
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></div>
        }
      </label>

      {props.children}
    </div>
  )
}

export default FilePickerOverlay
